.single {
  height: 45px;
  align-items: center;
}
